import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TasksService } from '@compumark/analyst-selection-tool-client';

@Component({
  selector: 'app-too-many-results-dialog',
  standalone: false,
  templateUrl: './too-many-results-dialog.component.html',
})
export class TooManyResultsDialogComponent {
  isSubmitting = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private taskService: TasksService,
    private dialogRef: MatDialogRef<TooManyResultsDialogComponent>,
  ) {}

  continueSearch(): void {
    this.isSubmitting = true;
    this.taskService.continueSearch(this.data.resultDeliveryId).subscribe({
      next: () => this.dialogRef.close(true),
      error: () => {
        this.isSubmitting = false;
      },
    });
  }
}
